import React, { memo } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCommentIcon from "@mui/icons-material/AddComment";
import HistoryIcon from "@mui/icons-material/History";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { ReactComponent as ChatbotIcon } from "../../../../../assets/img/chatbot.svg";

interface ChatHeaderProps {
    isMobile: boolean;
    isMaximized: boolean;
    isHistoryOpen: boolean;
    onNewChat?: () => void;
    onToggleHistory: () => void;
    onToggleMaximize: () => void;
    onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = memo(({
    isMobile,
    isMaximized,
    isHistoryOpen,
    onNewChat,
    onToggleHistory,
    onToggleMaximize,
    onClose,
}) => {
    const handleStopPropagation = (e: React.MouseEvent) => {
        if (!isMobile) e.stopPropagation();
    };

    return (
        <Box
            className={!isMobile ? "chat-header-drag" : ""}
            sx={{
                background: "#e4edef",
                color: "#1e293b",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2.5,
                py: 1.5,
                borderBottom: "1px solid #5FB7CF",
                cursor: isMobile || isMaximized ? "default" : "grab",
                "&:active": { cursor: isMobile || isMaximized ? "default" : "grabbing" },
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ChatbotIcon style={{ width: 24, height: 24 }} />
                <Typography variant="subtitle1" fontWeight={600} color="#073857">
                    HACS Agent
                </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="New Chat" arrow>
                    <IconButton
                        size="small"
                        onClick={onNewChat}
                        sx={{ color: "#475569" }}
                        onMouseDown={handleStopPropagation}
                    >
                        <AddCommentIcon fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="History" arrow>
                    <IconButton
                        size="small"
                        onClick={onToggleHistory}
                        sx={{ color: isHistoryOpen ? "#073857" : "#475569" }}
                        onMouseDown={handleStopPropagation}
                    >
                        <HistoryIcon />
                    </IconButton>
                </Tooltip>

                {!isMobile && (
                    <Tooltip title={isMaximized ? "Exit Fullscreen" : "Fullscreen"} arrow>
                        <IconButton
                            size="small"
                            onClick={onToggleMaximize}
                            sx={{ color: "#475569" }}
                            onMouseDown={handleStopPropagation}
                        >
                            {isMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
                        </IconButton>
                    </Tooltip>
                )}

                <Tooltip title="Close" arrow>
                    <IconButton
                        size="small"
                        onClick={onClose}
                        sx={{ color: "#475569" }}
                        onMouseDown={handleStopPropagation}
                    >
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
});

export default ChatHeader;